import { createCommand, getPluginState } from './plugin-factory';
import { ACTIONS } from './states';
import { getDiffObjects } from './utils';
import { fetchAIParagraphs } from './api';
import { resetAllDecorations } from './decorations';
export const createRealtimeAICommand = async ({
  state,
  generativeAIApiUrl,
  getFetchCustomHeaders
}) => {
  const paragraphType = state.schema.nodes.paragraph;
  const paragraphs = [];
  // Just a list of paragraph strings for now - this is very naive
  state.doc.descendants((node, pos) => {
    if (node.type === paragraphType && node.textContent.length > 0) {
      const inlineNodePositions = [];
      node.descendants((node, pos) => {
        if (node.isInline && !node.isText) {
          inlineNodePositions.push(pos);
        }
      });
      paragraphs.push({
        text: node.textContent,
        from: pos,
        to: pos + node.nodeSize,
        inlineNodePositions
      });
    }
  });
  const promises = await fetchAIParagraphs(generativeAIApiUrl, paragraphs);
  if (promises.length !== paragraphs.length) {
    // this shouldn't happen, but leaving this in for now
    return () => false;
  }
  const diffObjects = getDiffObjects(promises, paragraphs);
  return createCommand(state => {
    const pluginState = getPluginState(state);
    const {
      decorationSet
    } = pluginState;

    // TODO: if the Diff has been changed then we want to update the plugin state
    // else no change then return false;
    return {
      type: ACTIONS.UPDATE_DIFF_OBJECTS,
      data: {
        diffObjects,
        decorationSet: resetAllDecorations({
          decorationSet,
          tr: state.tr,
          pluginState: {
            ...pluginState,
            diffObjects
          }
        })
      }
    };
  }, (tr, state) => {
    return tr.setMeta('addToHistory', false);
  });
};
export const insertSuggestion = (from, to, tr) => createCommand(state => {
  const pluginState = getPluginState(state);
  const {
    decorationSet,
    diffObjects: currentDiffObjects
  } = pluginState;
  if (!currentDiffObjects) {
    return false;
  }
  const diffObjects = currentDiffObjects.filter(({
    from: _from,
    to: _to
  }) => from !== _from && to !== _to);
  return {
    type: ACTIONS.UPDATE_DIFF_OBJECTS,
    data: {
      diffObjects,
      // Upon inserting a suggestion we need to ensure that that the insertion widget is removed.
      decorationSet: resetAllDecorations({
        decorationSet,
        tr: tr || state.tr,
        pluginState: {
          ...pluginState,
          diffObjects
        }
      })
    }
  };
}, (originalTr, state) => {
  const {
    schema
  } = state;
  const {
    diffObjects
  } = getPluginState(state);
  const {
    selection
  } = tr || originalTr;
  if (diffObjects && selection.from === selection.to) {
    const selectedDiff = diffObjects === null || diffObjects === void 0 ? void 0 : diffObjects.find(({
      from,
      to
    }) => selection.from <= to && selection.from >= from);
    if (selectedDiff) {
      const {
        from,
        to,
        text
      } = selectedDiff;
      return (tr || originalTr).replaceWith(from, to, schema.text(text));
    }
  }
  return tr || originalTr;
});
export const removeSuggestion = (from, to, tr) => createCommand(state => {
  const pluginState = getPluginState(state);
  const {
    decorationSet,
    diffObjects: currentDiffObjects
  } = pluginState;
  if (!currentDiffObjects) {
    return false;
  }
  const diffObjects = currentDiffObjects.filter(({
    from: _from,
    to: _to
  }) => from !== _from && to !== _to);
  return {
    type: ACTIONS.UPDATE_DIFF_OBJECTS,
    data: {
      diffObjects,
      decorationSet: resetAllDecorations({
        decorationSet,
        tr: tr || state.tr,
        pluginState: {
          ...pluginState,
          diffObjects
        }
      })
    }
  };
});
export const toggleSpellingAndGrammar = () => createCommand({
  type: ACTIONS.TOGGLE_SPELLING_AND_GRAMMAR_ENABLED
});